import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from "../../../../i18next";

import { 
    loadAllTenderTypes,
    loadCollectionSettings,
    updateCollectionSettings,
    resetCollectionSettings,
    resetTenderTypes,
    getPaymentSettings } from '../../../../actions/index';
import ServiceSettings from './ServiceSettings';
import {getCurrencySymbol} from "../../../../utils/CommonUtils";
import { MENUU_ADMIN, MENUU_MASTER_ADMIN } from '../../../../utils/Constants';

class CollectionScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            settingsData: []
        }

        this.updateCollectionSettings = this.updateCollectionSettings.bind(this);
    }

    componentDidMount() {
        const { role } = this.props.currentlyLoggedInUser; 
        this.props.loadAllTenderTypes();
        const restaurantId = this.props.match.params.id;
        this.props.loadCollectionSettings(restaurantId);
        // Response and callback are used to prepopulate payment types
        if (role === MENUU_MASTER_ADMIN) {
            this.props.getPaymentSettings(restaurantId);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.collectionSettings !== prevProps.collectionSettings) {
            this.setState({
                settingsData: this.props.collectionSettings
            });
        }
    }

    componentWillUnmount() {
        this.props.resetCollectionSettings();
        this.props.resetTenderTypes();
    }

    updateCollectionSettings(settings, callback) {
        const restaurantId = this.props.match.params.id;
        let filteredPrepTimes = [];

        if (this.props.serviceSettingsGeneral.timeSlotBased) {
            settings.timeSlots = [...settings.preparationTimes];
            settings.preparationTimes = [];
        } else {
            settings.preparationTimes.map(prepTime => {
                let prepTimeCopy = {...prepTime};
                delete prepTimeCopy.maxOrders;
                delete prepTimeCopy.maxValue;
                delete prepTimeCopy.duration;

                filteredPrepTimes.push(prepTimeCopy);
            });

            settings.preparationTimes = filteredPrepTimes;
        }

        this.props.updateCollectionSettings(restaurantId, settings, callback);
    }

    render() {
        const deliveryTranslation = i18n.t('common:deliveryCollectionDineInCurbside.operationHoursCollection');
        const currency = getCurrencySymbol(this.props.restaurant.currency);

        return (
            <ServiceSettings
                settings={this.props.collectionSettings}
                prepopulatedSettings={this.state.settingsData}
                updateSettings={this.updateCollectionSettings}
                tenderTypes={this.props.tenderTypes}
                translationPhrase={deliveryTranslation}
                currency={currency}
                timeSlotBased={this.props.serviceSettingsGeneral.timeSlotBased}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        serviceSettingsGeneral: state.serviceSettingsGeneral,
        collectionSettings: state.collectionSettings,
        tenderTypes: state.tenderTypes,
        restaurant: state.restaurant,
        currentlyLoggedInUser: state.user
    }
}

export default connect(mapStateToProps, { 
    loadAllTenderTypes,
    loadCollectionSettings,
    updateCollectionSettings,
    resetCollectionSettings,
    resetTenderTypes,
    getPaymentSettings })(CollectionScreen);



// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/CollectionScreen.js